import { render, staticRenderFns } from "./ConfirmWithPassword.vue?vue&type=template&id=b8f0f7ac"
import script from "./ConfirmWithPassword.vue?vue&type=script&lang=ts"
export * from "./ConfirmWithPassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports